var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "md-layout" }, [
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25",
      },
      [
        _c(
          "stats-card",
          { attrs: { "header-color": "blue" } },
          [
            _c("template", { slot: "header" }, [
              _c("div", { staticClass: "card-icon" }, [
                _c("i", { staticClass: "fas fa-coins" }),
              ]),
              _c("p", { staticClass: "category" }, [
                _vm._v("Revenue Made Last Month"),
              ]),
              _c(
                "h3",
                { staticClass: "title" },
                [
                  _vm._v("R"),
                  _c("animated-number", { attrs: { value: 2000 } }),
                ],
                1
              ),
            ]),
            _c("template", { slot: "footer" }, [
              _c(
                "div",
                { staticClass: "stats" },
                [_c("md-icon", [_vm._v("date_range")]), _vm._v(" June")],
                1
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25",
      },
      [
        _c(
          "stats-card",
          { attrs: { "header-color": "rose" } },
          [
            _c("template", { slot: "header" }, [
              _c("div", { staticClass: "card-icon" }, [
                _c("i", { staticClass: "fas fa-coins" }),
              ]),
              _c("p", { staticClass: "category" }, [
                _vm._v("Revenue Made This Month"),
              ]),
              _c(
                "h3",
                { staticClass: "title" },
                [
                  _vm._v("R"),
                  _c("animated-number", { attrs: { value: 5000 } }),
                ],
                1
              ),
            ]),
            _c("template", { slot: "footer" }, [
              _c(
                "div",
                { staticClass: "stats" },
                [_c("md-icon", [_vm._v("date_range")]), _vm._v(" July")],
                1
              ),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25",
      },
      [
        _c(
          "stats-card",
          { attrs: { "header-color": "green" } },
          [
            _c("template", { slot: "header" }, [
              _c("div", { staticClass: "card-icon" }, [
                _c("i", { staticClass: "fas fa-business-time" }),
              ]),
              _c("p", { staticClass: "category" }, [
                _vm._v("Jobs Completed Last Month"),
              ]),
              _c(
                "h3",
                { staticClass: "title" },
                [_c("animated-number", { attrs: { value: 20 } })],
                1
              ),
            ]),
            _c("template", { slot: "footer" }, [
              _c("div", { staticClass: "stats" }, [
                _c(
                  "div",
                  { staticClass: "stats" },
                  [_c("md-icon", [_vm._v("date_range")]), _vm._v(" June")],
                  1
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25",
      },
      [
        _c(
          "stats-card",
          { attrs: { "header-color": "warning" } },
          [
            _c("template", { slot: "header" }, [
              _c("div", { staticClass: "card-icon" }, [
                _c("i", { staticClass: "fas fa-briefcase" }),
              ]),
              _c("p", { staticClass: "category" }, [
                _vm._v("Jobs Completed This Month"),
              ]),
              _c(
                "h3",
                { staticClass: "title" },
                [_c("animated-number", { attrs: { value: 2 } })],
                1
              ),
            ]),
            _c("template", { slot: "footer" }, [
              _c("div", { staticClass: "stats" }, [
                _c(
                  "div",
                  { staticClass: "stats" },
                  [_c("md-icon", [_vm._v("date_range")]), _vm._v(" July")],
                  1
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "h3",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
      },
      [_vm._v("Recent Projects")]
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33",
      },
      [
        _c(
          "product-card",
          { attrs: { "header-animation": "true" } },
          [
            _c("img", {
              staticClass: "img",
              attrs: { slot: "imageHeader", src: _vm.product1 },
              slot: "imageHeader",
            }),
            _c(
              "md-icon",
              { attrs: { slot: "fixed-button" }, slot: "fixed-button" },
              [_vm._v("build")]
            ),
            _c(
              "template",
              { slot: "first-button" },
              [
                _c("md-icon", [_vm._v("art_track")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("View"),
                ]),
              ],
              1
            ),
            _c(
              "template",
              { slot: "second-button" },
              [
                _c("md-icon", [_vm._v("edit")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("Edit"),
                ]),
              ],
              1
            ),
            _c(
              "template",
              { slot: "third-button" },
              [
                _c("md-icon", [_vm._v("close")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("Remove"),
                ]),
              ],
              1
            ),
            _c(
              "h4",
              { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
              [
                _c("a", { attrs: { href: "#pablo" } }, [
                  _vm._v("Cozy 5 Stars Apartment"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "card-description",
                attrs: { slot: "description" },
                slot: "description",
              },
              [
                _vm._v(
                  ' The place is close to Barceloneta Beach and bus stop just 2 min by walk and near to "Naviglio" where you can enjoy the main night life in Barcelona. '
                ),
              ]
            ),
            _c("template", { slot: "footer" }, [
              _c("div", { staticClass: "price" }, [
                _c("h4", [_vm._v("$899/night")]),
              ]),
              _c("div", { staticClass: "stats" }, [
                _c(
                  "p",
                  { staticClass: "category" },
                  [
                    _c("md-icon", [_vm._v("place")]),
                    _vm._v(" Barcelona, Spain "),
                  ],
                  1
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33",
      },
      [
        _c(
          "product-card",
          { attrs: { "header-animation": "true" } },
          [
            _c("img", {
              staticClass: "img",
              attrs: { slot: "imageHeader", src: _vm.product2 },
              slot: "imageHeader",
            }),
            _c(
              "md-icon",
              { attrs: { slot: "fixed-button" }, slot: "fixed-button" },
              [_vm._v("build")]
            ),
            _c(
              "template",
              { slot: "first-button" },
              [
                _c("md-icon", [_vm._v("art_track")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("View"),
                ]),
              ],
              1
            ),
            _c(
              "template",
              { slot: "second-button" },
              [
                _c("md-icon", [_vm._v("edit")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("Edit"),
                ]),
              ],
              1
            ),
            _c(
              "template",
              { slot: "third-button" },
              [
                _c("md-icon", [_vm._v("close")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("Remove"),
                ]),
              ],
              1
            ),
            _c(
              "h4",
              { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
              [
                _c("a", { attrs: { href: "#pablo" } }, [
                  _vm._v("Office Studio"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "card-description",
                attrs: { slot: "description" },
                slot: "description",
              },
              [
                _vm._v(
                  ' The place is close to Metro Station and bus stop just 2 min by walk and near to "Naviglio" where you can enjoy the night life in London, UK. '
                ),
              ]
            ),
            _c("template", { slot: "footer" }, [
              _c("div", { staticClass: "price" }, [
                _c("h4", [_vm._v("$1.119/night")]),
              ]),
              _c("div", { staticClass: "stats" }, [
                _c(
                  "p",
                  { staticClass: "category" },
                  [_c("md-icon", [_vm._v("place")]), _vm._v(" London, UK ")],
                  1
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass:
          "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33",
      },
      [
        _c(
          "product-card",
          { attrs: { "header-animation": "true" } },
          [
            _c("img", {
              staticClass: "img",
              attrs: { slot: "imageHeader", src: _vm.product3 },
              slot: "imageHeader",
            }),
            _c(
              "md-icon",
              { attrs: { slot: "fixed-button" }, slot: "fixed-button" },
              [_vm._v("build")]
            ),
            _c(
              "template",
              { slot: "first-button" },
              [
                _c("md-icon", [_vm._v("art_track")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("View"),
                ]),
              ],
              1
            ),
            _c(
              "template",
              { slot: "second-button" },
              [
                _c("md-icon", [_vm._v("edit")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("Edit"),
                ]),
              ],
              1
            ),
            _c(
              "template",
              { slot: "third-button" },
              [
                _c("md-icon", [_vm._v("close")]),
                _c("md-tooltip", { attrs: { "md-direction": "bottom" } }, [
                  _vm._v("Remove"),
                ]),
              ],
              1
            ),
            _c(
              "h4",
              { staticClass: "title", attrs: { slot: "title" }, slot: "title" },
              [
                _c("a", { attrs: { href: "#pablo" } }, [
                  _vm._v("Beautiful Castle"),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "card-description",
                attrs: { slot: "description" },
                slot: "description",
              },
              [
                _vm._v(
                  ' The place is close to Metro Station and bus stop just 2 min by walk and near to "Naviglio" where you can enjoy the main night life in Milan. '
                ),
              ]
            ),
            _c("template", { slot: "footer" }, [
              _c("div", { staticClass: "price" }, [
                _c("h4", [_vm._v("$459/night")]),
              ]),
              _c("div", { staticClass: "stats" }, [
                _c(
                  "p",
                  { staticClass: "category" },
                  [_c("md-icon", [_vm._v("place")]), _vm._v(" Milan, Italy ")],
                  1
                ),
              ]),
            ]),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }